import { Tabs, TabsList } from "@nexus/ui"
import { useTranslation } from "react-i18next"
import type { OpportunityTabCounts, OpportunityTabKey } from "../../../types/opportunities.types"

export interface OpportunitiesStatusTabsProps {
  counts: OpportunityTabCounts
  activeTab: OpportunityTabKey
  onTabChange: (tab: OpportunityTabKey) => void
  showOrdersTab?: boolean
}

const BASE_TAB_KEYS: OpportunityTabKey[] = ["active", "completed_scripts", "rejected"]

const tabI18nMap: Record<OpportunityTabKey, string> = {
  active: "opportunities.tabs.active",
  completed_scripts: "opportunities.tabs.completedScripts",
  orders: "opportunities.tabs.orders",
  rejected: "opportunities.tabs.rejected",
}

export function OpportunitiesStatusTabs({
  counts,
  activeTab,
  onTabChange,
  showOrdersTab = false,
}: OpportunitiesStatusTabsProps) {
  const { t } = useTranslation()

  const tabKeys: OpportunityTabKey[] = showOrdersTab
    ? ["active", "completed_scripts", "orders", "rejected"]
    : BASE_TAB_KEYS

  const alwaysVisible: OpportunityTabKey[] = showOrdersTab
    ? ["completed_scripts", "orders", "rejected"]
    : ["completed_scripts", "rejected"]

  const visibleTabs = tabKeys.filter(
    (key) => key === activeTab || alwaysVisible.includes(key) || counts[key] > 0,
  )

  return (
    <Tabs value={activeTab} onValueChange={(v) => onTabChange(v as OpportunityTabKey)}>
      <TabsList
        variant="line"
        options={visibleTabs.map((key) => ({
          value: key,
          label: t(tabI18nMap[key]),
          badge: counts[key],
        }))}
      />
    </Tabs>
  )
}
